import React, { useContext } from "react";
import Utils from "../utilities/utils";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import StoreContext from "../store/StoreContext";
function Navbar({ setisFullPageLayout }) {
  const { state, dispatch, StateFunction } = useContext(StoreContext);
  const toggleOffcanvas = () => {
    document.querySelector(".sidebar-offcanvas").classList.toggle("active");
  };

  let subcriptiondetails = JSON.parse(localStorage.getItem("Org_details"));
  const Orgadmindeatils = subcriptiondetails?.map((e) => e.contactdetails)[0];
  let orgname = Orgadmindeatils?.Name;
  const history = useHistory();
  const logoutHandler = (evt) => {
    evt.preventDefault();
    setisFullPageLayout(false);
    document
      .querySelector(".page-body-wrapper")
      .classList.add("full-page-wrapper");
    Utils.removeLocal("TypeOfUser");
    Utils.removeLocal("Role");
    Utils.removeLocal("Org_details");
    Utils.removeLocal("Org_id");
    history.push("/login");
    Utils.deleteCookie("token_org");
  };
  return (
    <div>
      {/* <nav
        className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row"
        style={{ borderBottom: "1px solid #484848"}}
      > */}
      <nav
        className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row"
        // style={{ borderBottom: "1px solid #484848" }}
      >
        <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center bg-dark">
          <Link
            className="navbar-brand brand-logo-sm bg-dark"
            to="/EnquireDetails"
            // style={{ backgroundColor: "red", border: "0px solid #fff" }}
          >
            <img src={require("../assets/images/sdp-refresh.png")} alt="logo" />
          </Link>
          {/* <Link className="navbar-brand brand-logo-sm" to="/">
            <img src={require("../assets/images/sdp-refresh.png")} alt="logo" />
          </Link> */}
        </div>
        <div
          className="navbar-menu-wrapper d-flex align-items-stretch"
          style={{ borderBottom: "1px solid #484848" }}
        >
          {/* <button
            className="navbar-toggler navbar-toggler align-self-center "
            type="button"
            onClick={() => document.body.classList.toggle("sidebar-icon-only")}
          > */}
          <button
            className="navbar-toggler navbar-toggler align-self-center"
            style={{ marginRight: "auto" }}
            type="button"
            onClick={() => document.body.classList.toggle("sidebar-icon-only")}
          >
            <span className="mdi mdi-arrow-left-circle"></span>
          </button>
          <ul className="navbar-nav navbar-nav-right">
            <li>
              <div>
                <span
                  className={"mdi mdi-reload h3 text-purple"}
                  role={"button"}
                  onClick={() => {
                    StateFunction.EnquiryDetailsApiCall(dispatch);
                    StateFunction.RolemasterApiCall(dispatch);
                    StateFunction.PlanmasterApiCall(dispatch);
                    StateFunction.ProductmasterApiCall(dispatch);
                    StateFunction.SubscriptionLicense(dispatch, state);
                    StateFunction.SubscriptionDetailsApiCall(dispatch, state);
                    StateFunction.UserRoleMapdetialsApiCall(dispatch, state);
                    StateFunction.OrginfoDetailsApiCall(dispatch);
                  }}
                ></span>
              </div>
            </li>
            <li className="nav-item nav-profile">
              <Dropdown>
                <Dropdown.Toggle className="nav-link">
                  <div className="nav-profile-img">
                    <img
                      src={require("../assets/images/faces/person.png")}
                      alt="user"
                    />
                    <span className="availability-status online"></span>
                  </div>
                  <div className="nav-profile-text">
                    <p className="mb-1 text-black">
                      {orgname ? orgname : "Yozy Admin"}
                      {/* {usermail ? usermail : "Profile"} */}
                    </p>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu className="navbar-dropdown">
                  <Dropdown.Item onClick={(e) => logoutHandler(e)}>
                    <i className="mdi mdi-logout mr-2 text-primary"></i>
                    Sign out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>
          </ul>
          <button
            className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
            type="button"
            onClick={() => toggleOffcanvas()}
          >
            <span className="mdi mdi-menu"></span>
          </button>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
